import createVueComponent from '../createVueComponent';

const ChevronLeft = createVueComponent('ChevronLeftIcon', [
  ['polyline', { points: '15 18 9 12 15 6' }],
]);

export default ChevronLeft;
